import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AdaptActivationRepositoryService extends BaseRepositoryService<
  ModelRegistry['adapt-activation']
> {
  recordName = 'adapt-activation';
  implementMethods = ['findAll', 'createRecord', 'save', 'unloadRecords'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/adapt-activation': AdaptActivationRepositoryService;
  }
}
